module.exports = __webpack_public_path__ + "static/domestic_mental_obj02@2x-b8697ac6890a43c117a5a2d2e15d5e15.jpg";